import { useMutation } from '@apollo/client';
import { MUTATION_UPDATE_RECORD_HEADER } from 'graphql/mutations/bills';
import { QUERY_FIND_RECORD_HEADERS_WITH_FILTERING, QUERY_GET_RECORD_HEADERS } from 'graphql/queries/bills';
import {
    FindRecordHeaderWithFilteringVariables,
    IGetRecordHeaders,
    IGetRecordHeadersFiltered,
    RecordHeadersVariables
} from 'ui-component/records/types';
import { IUpdateRecordHeader } from 'ui-component/RecordView/types';

const QUERYTOUPDATETYPE = {
    FINDRECORDHEADER: 'FINDRECORDHEADER',
    FINDRECORDHEADERWITHFILTERING: 'FINDRECORDHEADERWITHFILTERING'
};

type QueryToUpdateType = keyof typeof QUERYTOUPDATETYPE;

export const useUpdateRecord = (recordId: string, recordTypeId: string, queryToUpdate: QueryToUpdateType = 'FINDRECORDHEADER') => {
    const [updateRecord, { loading: updatingRecord }] = useMutation<IUpdateRecordHeader>(MUTATION_UPDATE_RECORD_HEADER, {
        update(cache, { data }) {
            const tenant = Number(localStorage.getItem('tenant_id'));
            const updatedRecord = data?.updateRecordHeader;

            if (queryToUpdate === QUERYTOUPDATETYPE.FINDRECORDHEADER) {
                const allFields = cache.readQuery<IGetRecordHeaders, RecordHeadersVariables>({
                    query: QUERY_GET_RECORD_HEADERS,
                    variables: {
                        data: { id: Number(recordId), recordType: Number(recordTypeId) },
                        pagination: { offset: 0, limit: 1 }
                    }
                });

                if (!allFields || !updatedRecord) return;

                cache.writeQuery<IGetRecordHeaders, RecordHeadersVariables>({
                    query: QUERY_GET_RECORD_HEADERS,
                    variables: {
                        data: { id: Number(recordId), recordType: Number(recordTypeId) },
                        pagination: { offset: 0, limit: 1 }
                    },
                    data: {
                        findRecordHeader: {
                            total: allFields.findRecordHeader.total,
                            records: allFields.findRecordHeader.records.map((record) =>
                                Number(record.id) === Number(updatedRecord.id) ? updatedRecord : record
                            )
                        }
                    }
                });
            }

            if (queryToUpdate === QUERYTOUPDATETYPE.FINDRECORDHEADERWITHFILTERING) {
                const allFields = cache.readQuery<IGetRecordHeadersFiltered, FindRecordHeaderWithFilteringVariables>({
                    query: QUERY_FIND_RECORD_HEADERS_WITH_FILTERING,
                    variables: {
                        data: { recordTypeId: +recordTypeId, tenantId: +(tenant || 0), filters: { ids: [Number(recordId)] } },
                        pagination: { offset: 0, limit: 1 }
                    }
                });

                if (!allFields || !updatedRecord) return;

                cache.writeQuery<IGetRecordHeadersFiltered, FindRecordHeaderWithFilteringVariables>({
                    query: QUERY_FIND_RECORD_HEADERS_WITH_FILTERING,
                    variables: {
                        data: { recordTypeId: +recordTypeId, tenantId: +(tenant || 0), filters: { ids: [Number(recordId)] } },
                        pagination: { offset: 0, limit: 1 }
                    },
                    data: {
                        filterAndSortRecordHeader: {
                            total: allFields.filterAndSortRecordHeader.total,
                            records: allFields.filterAndSortRecordHeader.records.map((record) =>
                                Number(record.id) === Number(updatedRecord.id) ? updatedRecord : record
                            )
                        }
                    }
                });
            }
        }
    });

    return { updateRecord, updatingRecord };
};
